
import lazyload from './lazyload';
import './polyfills';
import initSimpleGallery from './modal-gallery';
import civicCookie from './civic-cookie';
import overlay from './menu-overlay';
import addGoogleDirections from './directions';
import attachKeyboardInteraction from './keyboard-click-event-handler';
import videoAutoplay from './video-autoplay';
import personalisation from './personalisation';
import retainFocus from './modal-focus';

import slider from './slider';

retainFocus();
lazyload();
overlay();
civicCookie();
videoAutoplay();

slider({
  container: '.shorts',
  responsive: {
    0: {
      items: 1,
      gutter: 10,
    },
    576: {
      items: 3,
      gutter: 10,
    },
    768: {
      items: 4,
      gutter: 10,
    },
    992: {
      items: 6,
      gutter: 10,
    },
  },
});

document.personalisation = personalisation;
document.personalisation.setPages();

const pels = document.querySelectorAll('.nav-link-personal');
if (pels.length > 0) {
  document.personalisation.populateBlock();
};

const ytSelector = '[data-youtube-id]';
const ytEls = document.querySelectorAll(ytSelector);
if (ytEls.length > 0) {
  import(/* webpackChunkName: "youtube-player-240228" */ './youtubePlayer')
      .then(({default: setup}) => {
        setup(ytSelector);
      });
};

const modalGalleries = document.querySelectorAll('.gallery-to-modal');

if (modalGalleries.length > 0) {
  initSimpleGallery('.gallery-to-modal', 'data-src-lg');
}

addGoogleDirections();

attachKeyboardInteraction('[tabindex="0"][data-toggle="collapse"]');
attachKeyboardInteraction('.keyboard-to-click');

const searchForms = document.querySelectorAll('.site-search-nav__icon');

searchForms.forEach( (item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    item.closest('form').submit();
  });
});

// add class to document if the dismiss banner cookie has been set

(function() {
  const cookies = document.cookie.split('; ');

  // if (cookies.includes('banner_dismissed=true')) {
  if (cookies.indexOf('banner_dismissed=true') >= 0) {
    const el = document.querySelector('.banner-alert');
    el.classList.add('d-none');
  } else {
    const el = document.querySelector('.banner-alert');
    el.classList.remove('d-none');
  };
})();

const bannerDismiss = document.querySelector('.banner-alert')
    .querySelectorAll('[data-dismiss="alert"]');

bannerDismiss.forEach( (item) => {
  item.addEventListener('click', (e) => {
    const cookieElements = [
      'banner_dismissed=true',
      'SameSite=Lax',
      'expires=Session',
      'path=/',
    ];

    document.cookie = cookieElements.join('; ');
  });
});


const searchFormToggle = document.getElementById('course-search-fields-toggle');

if (searchFormToggle) {
  searchFormToggle.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('course-search-fields-advanced')
        .classList.toggle('course-search-fields-show');
  });
}

const els = document.querySelectorAll('.navigation-overlay-trigger');

if (typeof els !== undefined) {
  els.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      document.getElementById('navigation-overlay')
          .classList.toggle('navigation-overlay-open');
    });
  });
}
